import * as React from 'react'
import { memo } from 'react'
const SvgArrowLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 5 7.313"
  >
    <path d="M0 3.938a11.9 11.9 0 0 1 3.952 3.375H5a16.907 16.907 0 0 0-.9-1.75 12.906 12.906 0 0 0-1.427-1.912c.357-.483 1.15-1.432 1.429-1.932A18.528 18.528 0 0 0 5 0H3.952A12.409 12.409 0 0 1 0 3.375Z" />
  </svg>
)
const Memo = memo(SvgArrowLeft)
export default Memo
